export const planKeys = {
    modules: {
        PSYCHO_QUIZ: 'promotionPsychologicalTest',
        SIGN_FORM: 'promotionRegistration',
        QUIZ: 'promotionQuiz',
        SURVEY: 'promotionSurvey',
        WIN_WHEEL: 'promotionRoulette',
        VOTE: 'promotionIssueVote',
        POKE_GAME: 'promotionPoke',
        SCRATCH_CARD: 'promotionScratchCard',
        INVOICE: 'promotionInvoiceTW',
        RED_ENVELOPE_RAIN: 'promotionRedEnvelope',
        PHOTO_UPLOAD: 'promotionImageUpload',
        CHECK_IN: 'promotionCheckIn',
        CONTEST_PHOTO_UPLOAD: 'promotionPhotoContest',
        PHOTO_FRAME_COMPOSITE: 'promotionCreativeFrame',
        SLOTS: 'promotionSlot',
        PICK_THE_PRIZE: 'promotionPickThePrize',
        MEMORY_MATCH: 'promotionMemoryMatch',
        COMMENT: 'promotionComment',
        CONTEST_ADMIN_UPLOAD: 'promotionVotingContest',
        CONTEST_PHOTO_FRAME_COMPOSITE: 'promotionFramedPhotoContest',
        CHALLENGE_PHOTO_FRAME_COMPOSITE: 'promotionPhotoChallenge',
        VIDEO_UPLOAD: 'promotionVideoUpload',
        CONTEST_VIDEO_UPLOAD: 'promotionVideoContest',
        INSTAGRAM: 'promotionInstagram',
        PURCHASE_REWARD: 'promotionPurchaseReward',
        POINTS_REDEEM: 'promotionPointsRedeem',
        MGM_SHARE: 'promotionMGMShare',
        SIGN_UP: 'promotionSignUp',
        MULTI_CHALLENGE: 'promotionMultiChallenge',
        ORDER_REWARD: 'promotionOrderReward',
        CART_REWARD: 'promotionCartReward',
        MISSION_REWARD_BY_STAFF: 'promotionMissionRewardByStaff',
        GIFT_CATCHER: 'promotionGiftCatcher',
        MAGIC_CUP: 'promotionMagicCup',
        MATCH3_BREAKER: 'promotionMatch3Breaker',
        RUN_TO_FUTURE: 'promotionRunToFuture',
        TOTAL_RESCUE: 'promotionTotalRescue',
        HIGHWAY_DODGE: 'promotionHighwayDodge',
        GASHAPON: 'promotionGashapon',
        GARAPON: 'promotionGarapon',
        AI_LOTTERY: 'promotionAILottery',
        AI_GAME: 'promotionAIGame'
    }
};

/**
 * @namespace 方案 planGroup
 * @property {number} [general=1] - 活動方案
 * @property {number} [point=2] - 點數方案
 */
export const planTypes = {
    PROMO_PLAN: 1,
    POINT_PLAN: 2
};
